(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["anvelope_sort_by"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function() {
            var urlParams = new URLSearchParams(window.location.search);
            var sortBy = urlParams.get('sort_by');
            var sortSelect = document.getElementById('sort_by');
            if (sortBy && sortSelect) {
            sortSelect.value = sortBy;
            }
        });
  } catch(e) { console.error(e); }
})();

})();
